import {useState} from "react";

import {Button} from "@/components/button/Button.tsx";
import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {ViewEditorProps} from "@/pages/checks/list/components/ViewEditor/ViewEditor.types.ts";
import {ViewEditorForm} from "@/pages/checks/list/components/ViewEditor/ViewEditorForm.tsx";

import styles from "./ViewEditor.module.scss";

const FORM_ID = "view-editor-form";

export const ViewEditor = ({show, onClose, onSave, onDelete, availableColumns, editingView}: ViewEditorProps) => {
  const [submitting, setSubmitting] = useState(false);

  return (
    <FormModal
      show={show}
      onCancel={onClose}
      title={editingView ? "Edit View" : "Create View"}
      formId={FORM_ID}
      submitBtnText="Save"
      disabled={submitting}
      dialogClassName={styles.viewEditorModal}
      size="lg"
      hasRequiredFields
      leftAction={
        editingView && onDelete ? (
          <Button variant="ghost" className="text-danger" onClick={onDelete} disabled={submitting}>
            Delete
          </Button>
        ) : undefined
      }
    >
      {show && (
        <ViewEditorForm
          key={editingView?.id ?? "new"}
          formId={FORM_ID}
          onSave={onSave}
          onSubmittingChange={setSubmitting}
          availableColumns={availableColumns}
          editingView={editingView}
        />
      )}
    </FormModal>
  );
};
